import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b01b84cc&scoped=true&lang=html&"
import script from "./couponDetail.js?vue&type=script&lang=js&"
export * from "./couponDetail.js?vue&type=script&lang=js&"
import style0 from "./couponDetail.styl?vue&type=style&index=0&lang=stylus&"
import style1 from "./resetVant.styl?vue&type=style&index=1&id=b01b84cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01b84cc",
  null
  
)

export default component.exports